import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_LEAGUE } from '@/modules/league/router';
import { leagueService } from '@/services/league';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useLeagueTierEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        itemId: route.params.itemId,
        tier: route.params.tier,
        name: '',
        point: 0,
        imageFile: null,
        image: null,
        imageStatus: null,
        season: null,
        canDelete: false
    });

    const validations = {
        name: { required },
        tier: { required, numeric, min: minValue(1), max: maxValue(3200) },
        point: { required, numeric, min: minValue(0), max: maxValue(3200) },
        imageFile: {}
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => leagueService.tier.get(model.itemId, model.tier),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_LEAGUE.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                leagueService.tier.update(model.itemId, model.tier, model.name, model.point, model.imageFile),
            onSuccess: () => router.push({ name: ROUTE_NAME_LEAGUE.TIER.INDEX, params: { itemId: model.itemId } })
        }),
        remove: crudAction.confirmAndRemove({
            request: () => leagueService.tier.remove(model.itemId, model.tier),
            onSuccess: () => router.push({ name: ROUTE_NAME_LEAGUE.TIER.INDEX, params: { itemId: model.itemId } })
        })
    };

    return { model, v$, fetch, actions };
}
